export default __webpack_public_path__ + "static/media/pet-partners-card-logo.3c69828f.svg";